<template>
    <div class="grid grid-cols-7 ">
        <div v-for="idx in 7" class="tooltip-activator relative"
             :key="idx">
            <div :class="`bg-next-${getColoriStati(idx-1)}`"
                 class="border rounded text-center text-xs font-bold text-white p-1">
                {{ getTooltip(idx-1) }}
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {ColoriStati, LabelStati, NomiStato} from "@/types";

@Options({
    name:'LegendaStatiCliente',
    computed: {
        LabelStati() {
            return LabelStati
        }
    },
    props: {}
})
export default class LegendaStatiCliente extends Vue {

    getColoriStati(EnumStato: number) {
        return ColoriStati[EnumStato]
    }

    getLabel(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return LabelStati[LabelStati.NEU]
        }
        return LabelStati[EnumStato]
    }

    getTooltip(EnumStato: number | undefined) {
        if (EnumStato == undefined) {
            return NomiStato[LabelStati.NEU]
        }
        return NomiStato[EnumStato]
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
